import { Checkbox } from "@mui/material";
import React from "react";
import { Form } from "react-bootstrap";

function PrmCheckBox(props) {
    return <Form.Check label={props.label} onChange={props.onChange} />
}

export default PrmCheckBox;